import { Component, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as Fuse from 'fuse.js';
import { Observable } from 'rxjs';
import { LmoCreatePurchaseOrderComponent } from '~lmo/components';
import { LmoFracFcpoService } from '~lmo/services/lmo-frac-fcpo.service';
import { setupSearch$ } from '~utilities/fuse';
import { PurchaseOrder } from '~v2Models/purchaseOrders.model';

const searchOptions: Fuse.FuseOptions<PurchaseOrder> = {
  distance: 100,
  keys: ['name', 'mineName', 'meshType'],
  location: 0,
  maxPatternLength: 16,
  minMatchCharLength: 1,
  shouldSort: true,
  threshold: 0.2,
};

@Component({
  selector: 'sa-lmo-purchase-orders',
  styleUrls: ['./lmo-purchase-orders.component.scss'],
  templateUrl: './lmo-purchase-orders.component.html',
})
export class LmoPurchaseOrdersComponent implements OnInit {
  @HostBinding('class') public className = 'mt-0 pt-0';
  public activePurchaseOrders$: Observable<PurchaseOrder[]>;
  public closedPurchaseOrders$: Observable<PurchaseOrder[]>;

  public activePurchaseOrdersLoaded$: Observable<boolean>;
  public closedPurchaseOrdersLoaded$: Observable<boolean>;

  public searchBar: FormControl;

  constructor(
    private purchaseOrderService: LmoFracFcpoService,
    fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this.searchBar = fb.control('');
  }

  public ngOnInit(): void {
    this.activePurchaseOrders$ = setupSearch$(
      this.purchaseOrderService.purchaseOrders$,
      this.searchBar,
      searchOptions,
      100,
    );

    this.closedPurchaseOrders$ = setupSearch$(
      this.purchaseOrderService.closedPurchaseOrders$,
      this.searchBar,
      searchOptions,
      100,
    );

    this.activePurchaseOrdersLoaded$ = this.purchaseOrderService.purchaseOrdersLoaded$;
    this.closedPurchaseOrdersLoaded$ = this.purchaseOrderService.closedPurchaseOrdersLoaded$;
  }

  public addForm() {
    const dialogRef = this.dialog.open(LmoCreatePurchaseOrderComponent, {
      maxHeight: '100vh',
      maxWidth: '968px',
      width: '50%',
    });

    dialogRef.afterClosed().subscribe((poId) => {
      if (poId) {
        this.router.navigateByUrl(`lmo/purchase_order/detail/${poId}`);
      }
    });
  }
}
